/* eslint-disable react-hooks/exhaustive-deps */
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { apiProd } from '../services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

interface UsersProviderProps {
  children: ReactNode;
}

export interface User {
  id: number;
  cpf_cnpj: string;
  nome: string;
  data_criacao: Date;
  status: boolean;
  id_perfil: number;
  email: string;
  celular: string;
  codigo_recuperacao: number;
  validade_codigo: Date;
}

export interface Credor {
  id_usuario_credor: string;
  id_usuario: number;
  id_credor: number;
  credor_infos: {
    id_credor: number;
    credor: string;
    nome_credor: string;
    conta_parcelamento: number;
    id_contratante: string;
    logo: string | null;
    credor_crm: number;
  };
}

interface UsersContextProps {
  user: UsersProps;
  currentCompany: Credor;
  setCurrentCompany: (value: Credor) => void;
  loadUser: (access_token: string) => Promise<UsersProps>;
  handleSignInUser: (user: string, password: string) => Promise<void>;
  handleSignOutUser: () => Promise<void>;
  setUser: (user: UsersProps) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export type UsersProps = {
  user: User;
  credors: Credor[];
};

export const UsersContext = createContext({} as UsersContextProps);

export function UsersProvider({ children }: UsersProviderProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentCompany, setCurrentCompany] = useState<Credor>(() => {
    return JSON.parse(localStorage.getItem('currentCompany')!);
  });
  const [user, setUser] = useState<UsersProps>({
    user: {
      id: 0,
      cpf_cnpj: '',
      nome: '',
      data_criacao: new Date(),
      status: true,
      id_perfil: 0,
      email: '',
      celular: '',
      codigo_recuperacao: 0,
      validade_codigo: new Date(),
    },
    credors: [],
  });

  const navigate = useNavigate();

  async function handleSignInUser(user: string, password: string) {
    try {
      const { data } = await apiProd.post('sessions', {
        cpf_cnpj: user,
        senha: password,
      });
      if (data.token) {
        localStorage.setItem('access_token', data.token);
        Cookies.set('isAuthenticated', 'true');
      }
    } catch (err) {
      toast.error('Usuário ou senha incorreto', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  }

  async function loadUser(access_token: string) {
    const res = await apiProd.get('users-credor', {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
    localStorage.setItem('user', JSON.stringify(res.data.user));
    localStorage.setItem('credores', JSON.stringify(res.data.credors));
    return {
      user: res.data.user,
      credors: res.data.credors,
    };
  }
  async function handleSignOutUser() {
    localStorage.clear();
    window.location.href = 'https://painel.acionaone.com.br/login';
  }

  useEffect(() => {
    localStorage.setItem('currentCompany', JSON.stringify(currentCompany));
  }, [currentCompany]);

  async function fetchAccess() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const message = urlParams.get('message');
      if (message) {
        const decryptedMessage = atob(message);
        const infos = decryptedMessage.split(':');
        const login = infos[0];
        const password = infos[1];
        if (login && password) {
          await handleSignInUser(login, password);
          const token = localStorage.getItem('access_token');
          if (token) {
            const { credors } = await loadUser(token);
            setCurrentCompany(credors[0]);
            console.log("chegou here", token)
            navigate('/dashboard');
          }
        }
      }
    } catch (err) {
      window.location.href = 'https://painel.acionaone.com.br/login';
    }
  }

  useEffect(() => {
    fetchAccess();
  }, []);

  return (
    <UsersContext.Provider
      value={{
        setCurrentCompany,
        handleSignInUser,
        user,
        handleSignOutUser,
        loadUser,
        setUser,
        currentCompany,
        isAuthenticated,
        setIsAuthenticated,
        isOpen,
        setIsOpen,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
}

export const useSidebarDrawer = () => useContext(UsersContext);
